import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEye,
  faEyeSlash,
  faCircleExclamation,
} from '@fortawesome/free-solid-svg-icons';

// Etiketli, kontrollü metin alanı.
export const TextField = ({ id, label, ...props }) => (
  <div className="field">
    <label htmlFor={id}>{label}</label>
    <input id={id} {...props} />
  </div>
);

// Göster/gizle düğmeli şifre alanı.
export const PasswordField = ({ id, label, ...props }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <div className="password-wrap">
        <input
          id={id}
          type={visible ? 'text' : 'password'}
          {...props}
        />
        <button
          type="button"
          className="password-toggle"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? t('auth.password.hide') : t('auth.password.show')}
          aria-pressed={visible}
        >
          <FontAwesomeIcon icon={visible ? faEyeSlash : faEye} />
        </button>
      </div>
    </div>
  );
};

// Form üstü hata bildirimi.
export const ErrorBanner = ({ message }) => {
  if (!message) return null;
  return (
    <div className="auth-error" role="alert">
      <FontAwesomeIcon icon={faCircleExclamation} />
      <span>{message}</span>
    </div>
  );
};
